import React from 'react'
import classnames from 'classnames'
import useWindowScroll from '../../hooks/useWindowScroll'
import '../../styles/scroll-button.pcss'

const ScrollToTopButton = () => {
  const { scrollY, direction } = useWindowScroll()
  const show = scrollY > 160 && direction === 'up'

  const handleClick = () => {
    window.scroll({ top: 0, behavior: 'smooth' })
  }

  // https://fontawesome.com/v6/icons/circle-up?f=classic&s=solid
  return (
    <div className='scrollup-button-wrapper'>
      <button
        type='button'
        className={ classnames('scrollup-button', { 'sr-only sr-only-focusable': !show }) }
        onClick={ handleClick }
        title='Takaisin sivun alkuun'
      >
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' width='40' height='40'>
          <circle fill='white' cx='256' cy='256' r='200' />
          <path d='M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm11.3-395.3l112 112c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9l-64 0 0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-64 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0z' />
        </svg>
        <span className='sr-only'>Takaisin sivun alkuun</span>
      </button>
    </div>
  )
}

export default ScrollToTopButton
